import { normalizeDrivingRouteGroupKey } from "@utils/mode_tool/modeRoute";

export function resolveRawDirectionsPayload(rawValue) {
  if (!rawValue) return null;
  if (typeof rawValue === "string") {
    try {
      return JSON.parse(rawValue);
    } catch (error) {
      return null;
    }
  }
  if (typeof rawValue === "object") return rawValue;
  return null;
}

export function resolveRouteFromRaw(rawValue, options = {}) {
  const raw = resolveRawDirectionsPayload(rawValue);
  if (!raw) return null;
  const rawPreferredRouteKey = String(options?.routeKey || "")
    .trim()
    .toUpperCase();
  const preferredRouteKey =
    rawPreferredRouteKey && rawPreferredRouteKey !== "DEFAULT"
      ? normalizeDrivingRouteGroupKey(rawPreferredRouteKey)
      : "";
  if (Array.isArray(raw?.routes) && raw.routes[0]?.geometry)
    return raw.routes[0];
  if (
    raw?.routes &&
    typeof raw.routes === "object" &&
    !Array.isArray(raw.routes)
  ) {
    const normalizedRoutes = Object.entries(raw.routes).filter(
      ([, routeItem]) =>
        routeItem?.geometry &&
        Array.isArray(routeItem?.geometry?.coordinates),
    );
    const preferredRoute =
      preferredRouteKey && preferredRouteKey !== "main"
        ? raw?.routes?.[preferredRouteKey]
        : null;
    const mainRoute = raw?.routes?.main;

    if (preferredRoute?.geometry?.coordinates?.length) {
      return {
        geometry: preferredRoute.geometry,
        distance: Number(preferredRoute?.distance || 0),
        duration: Number(preferredRoute?.duration || 0),
      };
    }

    if (normalizedRoutes.length === 1) {
      const onlyRoute = normalizedRoutes[0][1];
      return {
        geometry: onlyRoute.geometry,
        distance: Number(onlyRoute?.distance || 0),
        duration: Number(onlyRoute?.duration || 0),
      };
    }

    if (normalizedRoutes.length > 1) {
      return {
        geometry: {
          type: "MultiLineString",
          coordinates: normalizedRoutes.map(
            ([, routeItem]) => routeItem.geometry.coordinates,
          ),
        },
        distance: normalizedRoutes.reduce(
          (total, [, routeItem]) => total + Number(routeItem?.distance || 0),
          0,
        ),
        duration: normalizedRoutes.reduce(
          (total, [, routeItem]) => total + Number(routeItem?.duration || 0),
          0,
        ),
      };
    }

    if (mainRoute?.geometry?.coordinates?.length) {
      return {
        geometry: mainRoute.geometry,
        distance: Number(mainRoute?.distance || 0),
        duration: Number(mainRoute?.duration || 0),
      };
    }
  }
  if (raw?.geometry && Array.isArray(raw?.geometry?.coordinates)) {
    return {
      geometry: raw.geometry,
      distance: Number(raw?.distance || 0),
      duration: Number(raw?.duration || 0),
    };
  }
  return null;
}
